import React, { useState, useContext, useEffect,useRef } from 'react';
import { UserContext } from '../../context/provider/UserProvider';
import Logobeex from '../../assets/images/Logobeex.fw.png'
import packageJson from '../../../package.json'

    
export const Principal = () => {
    const { stateUser, signOut } = useContext(UserContext)
    const version = packageJson.version

    // const loadURL = () => {
    //   const url = 'https://www.bbva.pe/'; // Reemplaza con la URL que desees cargar
    //   iframeRef.current.src = url;
    // };
  

    return (
        <>
           <section className='w-full h-full flex items-center justify-center'>
                <div className='flex flex-col opacity-60'>
                    <img src={Logobeex} />
                    <span className='w-full text-right text-xs'>v. {version}</span>
                </div>
            </section>
        </>
    )
}

